import CaseStudyPage from "@/pages/portfolio/components/CaseStudyPage";

export default function LogisticsCase() {
  return <CaseStudyPage slug="logistics-management-system" />;
}